module.exports = __webpack_public_path__ + "img/winners-list_in.65621d87.png";